import dispatcher from "./../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "../HttpRequests/HttpRequest";
import equipmentGroupConstants from "./../Constants/EquipmentGroupConstants";

class EquipmentGroupActions {
  getEquipmentGroupList(userid) {
    httpRequest(
      config.webServiceURL + "/AMGManagement?userid=" + userid,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENTGROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENTGROUP_FAILURE,
          });
        }
      },
    );
  }

  // getFonctions(equipmentGroup, language) {
  //   httpRequest(
  //     config.webServiceURL +
  //       "/AMGManagement/FonctionsbyEquipmentGroup?equipmentGroupID=" +
  //       equipmentGroup +
  //       "&language=" +
  //       language,
  //     "GET",
  //     null,
  //     (res) => {
  //       if (res !== "Error") {
  //         dispatcher.dispatch({
  //           type: equipmentGroupConstants.GET_NAVITEM_SUCCESS,
  //           result: res,
  //         });
  //       } else {
  //         dispatcher.dispatch({
  //           type: equipmentGroupConstants.GET_NAVITEM_FAILURE,
  //         });
  //       }
  //     }
  //   );
  // }

  //   getEquipmentList(
  //     equipmentGroupID,
  //     sort,
  //     direction,
  //     page = 1,
  //     pageSize = 1000,
  //     searchtext = ""
  //   ) {
  //     console.warn("in getEquipmentList, searchtext -=", searchtext);
  //     httpRequest(
  //       config.webServiceURL +
  //         "/AMGManagement/EquipmentListGrid2?equipmentGroupID=" +
  //         equipmentGroupID +
  //         "&page=" +
  //         page +
  //         "&pageSize=" +
  //         pageSize +
  //         "&option=INBE&sort=" +
  //         sort +
  //         "&direction=" +
  //         direction +
  //         "&search=" +
  //         searchtext,
  //       "GET",
  //       null,
  //       (res) => {
  //         if (res !== "Error") {
  //           dispatcher.dispatch({
  //             type: equipmentGroupConstants.GET_EQUIPMENTLIST_SUCCESS,
  //             result: res,
  //           });
  //         } else {
  //           dispatcher.dispatch({
  //             type: equipmentGroupConstants.GET_EQUIPMENTLIST_FAILURE,
  //           });
  //         }
  //       }
  //     );
  //   }

  getEquipmentList(
    equipmentGroupID,
    sort,
    direction,
    page = 1,
    pageSize = 1000,
    searchtext = "",
  ) {
    console.warn("in getEquipmentList, searchtext -=", searchtext);
    httpRequest(
      config.webServiceURL + "/AMGManagement/EquipmentListGrid2",
      "POST",
      JSON.stringify({
        equipmentGroupID: equipmentGroupID,
        sort: sort,
        direction: direction,
        page: parseInt(page),
        pageSize: parseInt(pageSize),
        option: "INBE",
        search: searchtext,
      }),
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENTLIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENTLIST_FAILURE,
          });
        }
      },
    );
  }

  getTabs(equipmentGroupID, language) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/TabMenubyEquipmentGroup?equipmentGroupID=" +
        equipmentGroupID +
        "&language=" +
        language,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_TABSMENU_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_TABSMENU_FAILURE,
          });
        }
      },
    );
  }

  getInaktivEquipments(
    equipmentGroupid,
    sort,
    order,
    page,
    pageSize,
    search = null,
  ) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/InactivEquipmentList?equipmentGroupID=" +
        equipmentGroupid +
        "&sort=" +
        sort +
        "&direction=" +
        order +
        "&page=" +
        page +
        "&pageSize=" +
        pageSize +
        "&search=" +
        search,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_INACTIVEQUIPMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_INACTIVEQUIPMENT_FAILURE,
          });
        }
      },
    );
  }

  getAuftraege(equipmentGroupid, sort, order, page, pageSize, search = null) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/AuftraegeUebersicht?equipmentGroupID=" +
        equipmentGroupid +
        "&sort=" +
        sort +
        "&direction=" +
        order +
        "&page=" +
        page +
        "&pageSize=" +
        pageSize +
        "&search=" +
        search,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_AUFTRAEGELIST_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_AUFTRAEGELIST_FAILURE,
          });
        }
      },
    );
  }
  // getAuftraegeNew(
  //   ReportId,
  //   Direction,
  //   EquipmentGroupID,
  //   page = 1,
  //   pageSize = 1000,
  //   SortHeaderText,
  //   Filter
  // ) {
  //   httpRequest(
  //     config.webServiceURL + "/PEGrid/ProcessRequest",
  //     "POST",
  //     JSON.stringify({
  //       ReportId: ReportId,
  //       Direction: Direction,
  //       EquipmentGroupID: EquipmentGroupID,
  //       Page: page,
  //       PageSize: pageSize,
  //       SortHeaderText: SortHeaderText,
  //       RequestFilters: Filter,
  //       // ReportId: "EquipList",
  //       // EquipmentGroupID: 144,
  //       // InventarNr: "InventarNr",
  //       // Direction: "asc",
  //       // Page: 1,
  //       // PageSize: 1000,
  //       // Option: "INBE",
  //       // search: "",
  //       // RequestFilters: [],
  //     }),
  //     (res) => {
  //       if (res !== "Error") {
  //         dispatcher.dispatch({
  //           type: equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_SUCCESS,
  //           result: res,
  //         });
  //       } else {
  //         dispatcher.dispatch({
  //           type: equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_FAILURE,
  //         });
  //       }
  //     }
  //   );
  //   httpRequest(
  //     config.webServiceURL +
  //       "/AMGManagement/AuftraegeUebersicht?equipmentGroupID=" +
  //       equipmentGroupid +
  //       "&sort=" +
  //       sort +
  //       "&direction=" +
  //       order +
  //       "&page=" +
  //       page +
  //       "&pageSize=" +
  //       pageSize +
  //       "&search=" +
  //       search,
  //     "GET",
  //     null,
  //     (res) => {
  //       if (res !== "Error") {
  //         dispatcher.dispatch({
  //           type: equipmentGroupConstants.GET_AUFTRAEGELIST_SUCCESS,
  //           result: res,
  //         });
  //       } else {
  //         dispatcher.dispatch({
  //           type: equipmentGroupConstants.GET_AUFTRAEGELIST_FAILURE,
  //         });
  //       }
  //     }
  //   );
  // }
  // getAuftraege_old(equipmentGroupid, page, pageSize, vondate,bisdata, search=null) {
  //   httpRequest(
  //      config.webServiceURL +
  //        '/AMGManagement/AuftraegeUebersicht?equipmentGroupID=' +
  //        equipmentGroupid +
  //        '&page=' +
  //        page +
  //        '&pageSize=' +
  //        pageSize+'&vondate='+vondate+'&bisdate='+bisdata + '&search='+search,
  //      'GET',
  //      null,
  //      (res) => {
  //        if (res !== 'Error') {
  //          dispatcher.dispatch({
  //            type: equipmentGroupConstants.GET_AUFTRAEGELIST_SUCCESS,
  //            result: res
  //          });
  //        } else {
  //          dispatcher.dispatch({
  //            type: equipmentGroupConstants.GET_AUFTRAEGELIST_FAILURE
  //          });
  //        }
  //      }
  //    );
  //  }

  // getUeberfaelligePrufung(
  // 	equipmentGroupid,
  // 	sort,
  // 	order,
  // 	page,
  // 	pageSize,
  // 	search = ""
  // ) {
  // 	httpRequest(
  // 		config.webServiceURL +
  // 			"/AMGManagement/UeberfaelligePrufung?equipmentGroupID=" +
  // 			equipmentGroupid +
  // 			"&sort=" +
  // 			sort +
  // 			"&direction=" +
  // 			order +
  // 			"&page=" +
  // 			page +
  // 			"&pageSize=" +
  // 			pageSize +
  // 			"&search=" +
  // 			search,
  // 		"GET",
  // 		null,
  // 		(res) => {
  // 			if (res !== "Error") {
  // 				dispatcher.dispatch({
  // 					type: equipmentGroupConstants.GET_UEBERFAELLIGEPRUFUNG_SUCCESS,
  // 					result: res,
  // 				});
  // 			} else {
  // 				dispatcher.dispatch({
  // 					type: equipmentGroupConstants.GET_UEBERFAELLIGEPRUFUNG_FAILURE,
  // 				});
  // 			}
  // 		}
  // 	);
  // }

  getUeberfaelligePrufung(
    equipmentGroupid,
    sort,
    order,
    page,
    pageSize,
    search = "",
  ) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/UeberfaelligePrufung",
      "POST",
      JSON.stringify({
        equipmentGroupID: equipmentGroupid,
        sort: sort,
        direction: order,
        page: parseInt(page),
        pageSize: parseInt(pageSize),
        search: search,
      }),
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_UEBERFAELLIGEPRUFUNG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_UEBERFAELLIGEPRUFUNG_FAILURE,
          });
        }
      },
    );
  }

  ExportUeberfaelligePrufung(equipmentGroupid, option, search = "") {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/ExportUeberfaellige?equipmentGroupID=" +
        equipmentGroupid +
        "&option=" +
        option +
        "&search=" +
        search,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.EXPORT_UEBERFAELLIGEPRUFUNG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.EXPORT_UEBERFAELLIGEPRUFUNG_FAILURE,
          });
        }
      },
    );
  }

  ExportNIOAnlage(equipmentGroupid, searchtext = "") {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/ExportNIOAnlage?equipmentGroupID=" +
        equipmentGroupid +
        "&search=" +
        searchtext,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.EXPORT_NIOANLAGE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.EXPORT_NIOANLAGE_FAILURE,
          });
        }
      },
    );
  }

  getExportDaten(
    equipmentGroupid,
    bildoption,
    requestFilt,
    reportCode,
    FilterId,
  ) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/ExportStammdaten?equipmentGroupID=",
      "POST",
      JSON.stringify({
        BildOption: bildoption,
        EquipmentGroupID: equipmentGroupid,
        RequestFilters: requestFilt,
        FilterId: FilterId,
        reportCode,
      }),
      (res, message) => {
        if (res !== "Error") {
          switch (reportCode) {
            case "EquipList":
            case "OrdersOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.EXPORT_SUCCESS,
                result: res,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.EXPORT_OVERDUE_SUCCESS,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: equipmentGroupConstants.EXPORT_NIO_SUCCESS,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.EXPORT_ORDEROVERVIEW_SUCCESS,
                result: res,
              });
              break;
          }
        } else {
          switch (reportCode) {
            case "EquipList":
            case "OrdersOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.EXPORT_FAILURE,
                result: message,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.EXPORT_OVERDUE_FAILURE,
                result: message,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: equipmentGroupConstants.EXPORT_NIO_FAILURE,
                result: message,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.EXPORT_ORDEROVERVIEW_FAILURE,
                result: message,
              });
              break;
          }
        }
      },
    );
  }

  getExportAuftraegeUebersichtWithImage(equipmentGroupid, searchtext = " ") {
    //, vondate, bisdate
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/ExportWithImage?equipmentGroupID=" +
        equipmentGroupid +
        "&search=" +
        searchtext,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.EXPORT_AUFTRAEGE_WITH_IMG_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.EXPORT_AUFTRAEGE_WITH_IMG_FAILURE,
          });
        }
      },
    );
  }

  getNIOAnlage(equipmentGroupid, sort, order, page, pageSize, searchtext = "") {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/NIOAnlage?equipmentGroupID=" +
        equipmentGroupid +
        "&sort=" +
        sort +
        "&direction=" +
        order +
        "&page=" +
        page +
        "&pageSize=" +
        pageSize +
        "&search=" +
        searchtext,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_NIOANLAGE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_NIOANLAGE_FAILURE,
          });
        }
      },
    );
  }

  getOrganisationsEquipmentGroup() {
    httpRequest(
      config.webServiceURL + "/AMGManagement/GetOrganizationEquipmentGroups",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_ORG_EQUIPMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_ORG_EQUIPMENT_FAILURE,
          });
        }
      },
    );
  }
  getManageTicketAnlagegruppes() {
    httpRequest(
      config.webServiceURL + "/AMGManagement/GetManageTicketAnlagegruppes",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_MANAGE_TICKET_EQUIPMENT_GRP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_MANAGE_TICKET_EQUIPMENT_GRP_FAILURE,
          });
        }
      },
    );
  }

  getPlantEquipmentGroups(werkId) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/GetPlantEquipmentGroups/" + werkId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_PLANT_EQUIPMENT_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_PLANT_EQUIPMENT_GROUP_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  createEquipmentGroup(equipmentGroupDetails) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/SaveOrUpdateAnlagegruppe",
      "PUT",
      JSON.stringify({
        ...equipmentGroupDetails,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_EQUIPMENT_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_EQUIPMENT_GROUP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  deleteEquipmentGroup(equipmentGroupId, plantId) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/DeleteEquipmentGroup/" + plantId,
      "DELETE",
      JSON.stringify([...equipmentGroupId]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_EQUIPMENT_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_EQUIPMENT_GROUP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  AddOrUpdateEquipment(BezeichnungDetails) {
    httpRequest(
      config.webServiceURL + "/EquipmentName/SaveOrUpdateBezeichnung",
      "PUT",
      JSON.stringify({
        ID: BezeichnungDetails.ID,
        Bezeichnung: BezeichnungDetails.Bezeichnung,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_EQUIPMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_EQUIPMENT_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getEquipment(startWith) {
    httpRequest(
      config.webServiceURL + "/EquipmentName/GetBezeichnungs/" + startWith,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENT_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  getHerstelleres(startWith) {
    httpRequest(
      config.webServiceURL + "/Manufacturer/GetHerstelleres/" + startWith,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_HERSTELLERS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_HERSTELLERS_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  addOrUpdateHerstelleres(herstelleresData) {
    httpRequest(
      config.webServiceURL + "/Manufacturer/SaveOrUpdateHersteller/",
      "PUT",
      JSON.stringify({
        ID: herstelleresData.ID,
        Hersteller: herstelleresData.Hersteller,
        // EigenHerstellung: true,
        EigenHerstellung:
          herstelleresData.EigenHerstellung == "true" ? true : false,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADD_OR_UPDATE_HERSTELLERS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADD_OR_UPDATE_HERSTELLERS_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  deleteHersteller(herstellerIDs) {
    httpRequest(
      config.webServiceURL + "/Manufacturer/DeleteHersteller",
      "DELETE",
      JSON.stringify([...herstellerIDs]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_HERSTELLRS_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_HERSTELLRS_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  deleteBezeichnung(bezeichnungID) {
    httpRequest(
      config.webServiceURL + "/EquipmentName/DeleteBezeichnung",
      "DELETE",
      JSON.stringify([...bezeichnungID]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_DESIGNATION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_DESIGNATION_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  AddAnlagegruppeBezeichnung(BezeichnungData) {
    httpRequest(
      config.webServiceURL + "/EquipmentName/AddAnlagegruppeBezeichnung/",
      "PUT",
      JSON.stringify({
        BezeichnungID: BezeichnungData.BezeichnungID,
        AnlagegruppeID: BezeichnungData.AnlagegruppeID,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADD_EQUIPMENT_TO_EQU_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADD_EQUIPMENT_TO_EQU_GROUP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getEquipmentByEquGrpId(equipmentGrpId) {
    httpRequest(
      config.webServiceURL +
        "/EquipmentName/GetAnlagegruppeBezeichnungs/" +
        equipmentGrpId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENT_BY_EQUGROUP_ID_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENT_BY_EQUGROUP_ID_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  deleteEquipmentForEquGroup(equGrpId, EquId) {
    const anlageDetails = {
      AnlagegruppeID: equGrpId,
      BezeichnungIDs: EquId,
    };
    httpRequest(
      config.webServiceURL + "/EquipmentName/RemoveAnlagegruppeBezeichnung",

      "DELETE",
      JSON.stringify(anlageDetails),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_EQUIPMENT_FOR_EQUGROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_EQUIPMENT_FOR_EQUGROUP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getHerstellerByEquGrpId(equipmentGrpId) {
    httpRequest(
      config.webServiceURL +
        "/Manufacturer/GetAnlagegruppeHerstelleres/" +
        equipmentGrpId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  addAnlagegruppeHersteller(herstellerData) {
    httpRequest(
      config.webServiceURL + "/Manufacturer/AddAnlagegruppeHersteller/",
      "PUT",
      JSON.stringify({
        HerstellerID: herstellerData.HerstellerID,
        AnlagegruppeID: herstellerData.AnlagegruppeID,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADD_HERSTELLER_BY_EQUIPMENT_GROUP_ID_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  deleteHerstellerForEquGroup(equGrpId, herstellerID) {
    const details = {
      AnlagegruppeID: equGrpId,
      HerstellerIDs: herstellerID,
    };
    httpRequest(
      config.webServiceURL + "/Manufacturer/RemoveAnlagegruppeHersteller",
      "DELETE",
      JSON.stringify(details),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_HERSTELLER_BY_EQUIPMENT_GROUP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  GetAnlagegruppeFonctions(anlagegruppeID) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/GetAnlagegruppeFonctions/" +
        anlagegruppeID,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_FUNCTION_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_FUNCTION_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  addOrUpdateAnlagegruppeFonctions(functionsData) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/SaveOrUpdateAnlagegruppeFonctions/",
      "PUT",
      JSON.stringify({
        AnlagegruppeID: functionsData.AnlagegruppeID,
        Fonctions: functionsData.Fonctions,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_FUNCTION_TO_EQU_GRP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_FUNCTION_TO_EQU_GRP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getAnlagegruppeMenupunktes(anlagegruppeID) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/GetAnlagegruppeMenupunktes/" +
        anlagegruppeID,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_MENU_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_MENU_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  addOrUpdateAnlagegruppeMenupunktes(menuData) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/SaveOrUpdateAnlagegruppeMenupunktes/",
      "PUT",
      JSON.stringify({
        AnlagegruppeID: menuData.AnlagegruppeID,
        Menupunktes: menuData.Menupunktes,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_MENU_TO_EQU_GRP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_MENU_TO_EQU_GRP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  addOrUpdateAnlagegruppeStandardAttributes(standardAttributesData) {
    httpRequest(
      config.webServiceURL +
        "/AnlagegruppeStandardAttribute/SaveOrUpdateAnlagegruppeStandardAttributes/",
      "PUT",
      JSON.stringify({
        AnlagegruppeID: standardAttributesData.AnlagegruppeID,
        AnlagegruppeStandardAttributeSaveUpdateModels:
          standardAttributesData.AnlagegruppeStandardAttributeSaveUpdateModels,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADDORUPDATE_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getAnlagegruppeStandardAttributes(anlagegruppeID) {
    httpRequest(
      config.webServiceURL +
        "/AnlagegruppeStandardAttribute/GetAnlagegruppeStandardAttributes/" +
        anlagegruppeID,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQU_GUP_STANDARD_ATTRIBUTES_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQU_GUP_STANDARD_ATTRIBUTES_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  removeAnlagegruppeStandardAttributes(Id) {
    httpRequest(
      config.webServiceURL +
        "/AnlagegruppeStandardAttribute/RemoveAnlagegruppeStandardAttributes/" +
        Id,
      "DELETE",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.REMOVE_STANDARD_ATTRIBUTES_EQU_GRP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getTestGroups(startWith) {
    httpRequest(
      config.webServiceURL +
        "/AnlagegruppePruefGroup/GetPruefGroups/" +
        startWith,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_TEST_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_TEST_GROUP_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  AddTestGroupToEquGroup(TestGroupData) {
    httpRequest(
      config.webServiceURL +
        "/AnlagegruppePruefGroup/AddAnlagegruppePruefGroup/",
      "POST",
      JSON.stringify({
        PruefGroupID: TestGroupData.PruefGroupID,
        AnlagegruppeID: TestGroupData.AnlagegruppeID,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADD_TEST_GROUP_TO_EQU_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.ADD_TEST_GROUP_TO_EQU_GROUP_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getTestGroupByEquGrpId(equipmentGrpId) {
    httpRequest(
      config.webServiceURL +
        "/AnlagegruppePruefGroup/GetAnlagegruppePruefGroups/" +
        equipmentGrpId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_TEST_GROUP_BY_EQUGROUP_ID_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_TEST_GROUP_BY_EQUGROUP_ID_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  deleteTestGroupForEquGroup(equGrpId, TestGroupId) {
    const details = {
      AnlagegruppeID: equGrpId,
      TestGroupIDs: TestGroupId,
    };
    httpRequest(
      config.webServiceURL +
        "/AnlagegruppePruefGroup/RemoveAnlagegruppePruefGroup",

      "DELETE",
      JSON.stringify(details),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_TEST_GROUP_FOR_EQUGROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.DELETE_TEST_GROUP_FOR_EQUGROUP_FAILURE,
            result: message,
          });
        }
      },
    );
  }
  setFixedDate(changeFixedDate) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/ChangeFixedDate",
      "POST",
      JSON.stringify({
        Date: changeFixedDate.fixedDate,
        EquipmentFilter: changeFixedDate.equipmentDetail,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_FIXED_DATESET_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_FIXED_DATESET_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  CopyEquipmentGroup(anlagegruppeData) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/CopyAnlagegruppe/",
      "POST",
      JSON.stringify({
        PlantId: anlagegruppeData.PlantId,
        ID: anlagegruppeData.ID,
        Bezeichnung: anlagegruppeData.Bezeichnung,
        Abkuerzung: anlagegruppeData.Abkuerzung,
        CopyFunctions: anlagegruppeData.CopyFunctions,
        CopyMenu: anlagegruppeData.CopyMenu,
        CopyAttribute: anlagegruppeData.CopyAttribute,
        CopyManufacturer: anlagegruppeData.CopyManufacturer,
        CopyTestGroup: anlagegruppeData.CopyTestGroup,
        CopyEquipmentName: anlagegruppeData.CopyEquipmentName,
        CopyPruefPlan: anlagegruppeData.CopyPruefPlan,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.COPY_EQUIPMENT_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.COPY_EQUIPMENT_GROUP_FAILURE,
            result: message,
          });
        }
      },
    );
  }
  getEquipmentList2(
    ReportId,
    Direction,
    EquipmentGroupID,
    page = 1,
    pageSize = 1000,
    SortHeaderText,
    FilterId,
    Filter,
  ) {
    httpRequest(
      config.webServiceURL + "/PEGrid/ProcessRequest",
      "POST",
      JSON.stringify({
        ReportId: ReportId,
        Direction: Direction,
        EquipmentGroupID: EquipmentGroupID,
        Page: page,
        PageSize: pageSize,
        SortHeaderText: SortHeaderText,
        FilterId: FilterId,
        RequestFilters: Filter,
      }),
      (res, message) => {
        if (res !== "Error") {
          switch (ReportId) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_SUCCESS,
                result: res,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_OVERDUE_EQUIPMENTLIST_SUCCESS,
                result: res,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_NIO_EQUIPMENTLIST_SUCCESS,
                result: res,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_SUCCESS,
                result: res,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_INACTIVE_EQUIPMENTLIST_SUCCESS,
                result: res,
              });
              break;
          }
        } else {
          switch (ReportId) {
            case "EquipList":
            case "OrdersOView":
            case "ScrapEquipment":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_EQUIPMENTLIST_FAILURE,
                result: message,
              });
              break;
            case "OverdueOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_OVERDUE_EQUIPMENTLIST_FAILURE,
                result: message,
              });
              break;
            case "NIOEquip":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_NIO_EQUIPMENTLIST_FAILURE,
                result: message,
              });
              break;
            case "OrdersOView":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_ORDEROVERVIEW_EQUIPMENTLIST_FAILURE,
                result: message,
              });
              break;
            case "InactivEquip":
              dispatcher.dispatch({
                type: equipmentGroupConstants.GET_GRID_INACTIVE_EQUIPMENTLIST_FAILURE,
                result: message,
              });
              break;
          }
        }
      },
    );
  }
  getOptionEqGrp(optType) {
    httpRequest(
      config.webServiceURL + "/Option/Gets/" + optType,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_OPTION_EQUIP_GRP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_OPTION_EQUIP_GRP_FAILURE,
            result: res,
          });
        }
      },
    );
  }
  getParticularEqGrp(equGrpId) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/GetEquipmentGroup/" + equGrpId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_PARTICULE_EQ_GRP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_PARTICULE_EQ_GRP_FAILURE,
            result: res,
          });
        }
      },
    );
  }
  getSummaryEqGrp(equGrpId) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/GetEquipmentGroupSummary/" +
        equGrpId,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_SUMMARY_EQ_GRP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_SUMMARY_EQ_GRP_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  getEquipmentGroupListByPlant(userid) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/GetPlantAnlageGroup",
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENTGROUP_BY_PLANT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_EQUIPMENTGROUP_BY_PLANT_FAILURE,
          });
        }
      },
    );
  }

  saveInspectionReportConfiguration(inspectionReportAttributes) {
    httpRequest(
      config.webServiceURL + "/AMGManagement/SaveInspectionReportConfiguration",
      "PUT",
      JSON.stringify({
        ...inspectionReportAttributes,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.SAVE_INSPECTION_REPORT_ATTR_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.SAVE_INSPECTION_REPORT_ATTR_FAILURE,
            result: message,
          });
        }
      },
    );
  }

  getInspectionReportConfiguration(anlagegruppeID) {
    httpRequest(
      config.webServiceURL +
        "/AMGManagement/GetInspectionReportConfiguration/" +
        anlagegruppeID,
      "GET",
      null,
      (res) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_INSPECTION_REPORT_CONF_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_INSPECTION_REPORT_CONF_FAILURE,
            result: res,
          });
        }
      },
    );
  }

  bulkExportInspectionReport(
    ReportId,
    Direction,
    EquipmentGroupID,
    page = 1,
    pageSize = 1000,
    SortHeaderText,
    FilterId,
    Filter,
    combineIntoSinglePdf,
  ) {
    httpRequest(
      config.webServiceURL + "/PEGrid/BulkExportInspection",
      "POST",
      JSON.stringify({
        ReportId: ReportId,
        Direction: Direction,
        EquipmentGroupID: EquipmentGroupID,
        Page: page,
        PageSize: pageSize,
        SortHeaderText: SortHeaderText,
        FilterId: FilterId,
        RequestFilters: Filter,
        CombineIntoSinglePdf: combineIntoSinglePdf,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_BULK_INSPECTION_REPORT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: equipmentGroupConstants.GET_BULK_INSPECTION_REPORT_FAILURE,
            result: message,
          });
        }
      },
    );
  }
}
export default new EquipmentGroupActions();
